import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { ApiResource } from '../../models/api-resource.interface';
import { WorkSchedule } from './work-schedule.interface';

export class WorkScheduleService {
   async getWorkSchedules(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<WorkSchedule>>>(`/nxt-work-schedules`, {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }
}
